<template>
  <div>
    <div class="router-header flex flex-wrap items-center mb-3">
      <div class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light">
      </div>
    </div>
    <div class="vx-row">
      <div
        v-for="comp in pendingReview"
        :key="comp.id"
        class="vx-col w-full"
      >
        <!-- FIXED: Replaced comp.i with method call -->
        <a :href="getSkillDetailsUrl(comp)" target="_blank" class="block">
          <div class="vx-card overflow-hidden mb-3 hover:bg-gray-50 transition-colors border border-gray-100 shadow-sm">
            <div class="p-4 flex items-center justify-start text-left">
              
              <!-- Avatar / Icon -->
              <div style="position: relative; display: inline-flex;">
                <span
                  class="inline-flex rounded-full select-none text-primary mc-icon"
                  style="background: rgba(var(--vs-primary),0.15); width: 54px; height: 54px; display: flex; align-items: center; justify-content: center;"
                >
                  <img :src="comp.icon" alt="" width="30px" height="30px" />
                </span>

                <span 
                  v-if="comp.motivationSurvey !== 1"
                  class="custom-status-dot warning" 
                  :title="comp.motivationSurvey === 2 ? $t('playerJourney.t3_2') : $t('playerJourney.t3_3')"
                ></span>
              </div>

              <!-- Title & Status Badge -->
              <div class="truncate ml-4 flex-grow text-left">
                <h5 class="mb-1 text-left font-semibold text-gray-800">{{ comp.comp }}</h5>
                <div class="flex items-center space-x-2 mt-1">
                  <span class="px-2 py-0.5 bg-blue-100 text-blue-600 text-xs font-bold rounded-md">
                    Pending Review
                  </span>
                  <span class="text-xs text-gray-400">Click to evaluate</span>
                </div>
              </div>
              
              <!-- Arrow Icon -->
              <div class="flex-shrink-0 text-gray-300">
                <feather-icon icon="ChevronRightIcon" svgClasses="w-6 h-6"></feather-icon>
              </div>

            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
// import ccd from "@/assets/data/charactersistic-competency-definition";
import constants from "../../../../constants.js";

// Store Module
// import moduleAddSkill from "@/store/add-skill/moduleCompetencyProgress.js";

export default {
  name: "MySkills",
  props: ['pendingReview'],
  data() {
    return {
      allCompetencies: [],
      CCD: this.$t("addNewSkill.data"),
      constants
    };
  },
  created() {},
  methods: {
    getSkillDetailsUrl(comp) {
      // Fix: Safely fall back to comp.i if comp.id is missing, though it should be id.
      const id = comp.id || comp.i; 
      
      let url = `${this.constants.url}/user/skill-details/${id}`;
      
      // Look for traineeName in props, data, route, or the comp object itself
      const name = this.traineeName || comp.traineeName || this.$route.query.traineeName;
      
      if (name) {
        // Append mentorView=true so the destination page knows to open in Read-Only mode
        url += `?traineeName=${encodeURIComponent(name)}&mentorView=true`;
      } else {
        url += `?mentorView=true`;
      }
      return url;
    }
  },
  mounted() {}
};
</script>

<style scoped>
.vx-card {
  cursor: pointer;
}

.vx-card:hover {
  background: #F9F9F9;
}

.competency-img {
  width: 30px;
  height: 30px;
  margin: auto;
}

.selectedCompetency {
  background: #9dcd5b! important;
  color: white! important;
}

.selected-competency .competency-title h4 {
  color: white;
}

.not-selected-competency {
}

.con-vs-card >>> .vs-card--content {
  padding: 3px 8px 3px 8px !important;
  margin-bottom: 10px;
}

.truncate {
  white-space: normal !important;
}

.truncate h5 {
  margin-left: 0 !important; 
}

.truncate span {
  display: none;
}

/* --- ADD THESE CLASSES FOR THE DOT --- */
.custom-status-dot {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1.5px solid #ffffff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.25);
  z-index: 10;
}

.custom-status-dot.warning {
  background-color: #FBBF15 !important; /* Bright Yellow */
}

.custom-status-dot.primary {
  background-color: rgba(var(--vs-primary), 1) !important;
}

.custom-status-dot.grey {
  background-color: #b8c2cc !important; /* Grey neutral color */
}

.selectedCompetency >>> span.mc-icon {
  background: #fff !important;
}

.selectedCompetency .truncate span {
  display: block !important;
}

.selectedCompetency .truncate h5 {
  color: white;
}
</style>
